import store from '../../store';

export default function apiHeaders () {
	const state = store.getState();
	return {headers: state.user.headers, ...{ withCredentials: true }};
}